/**
 * @license
 * Copyright 2022 Superflows.dev
 * SPDX-License-Identifier: MIT
 */

import {SfIExternalImport} from '../sf-i-external-import.js';
// import { stub } from 'sinon';
// import {fixture, assert} from '@open-wc/testing';
import {assert} from '@open-wc/testing';
// import {html} from 'lit/static-html.js';

//const TIMEOUT = 2000;
suite('sf-i-external-import > left menu', () => {

  test('is defined', () => {
    const el = document.createElement('sf-i-external-import');
    assert.instanceOf(el, SfIExternalImport);
  });


});

